import { Routable } from 'shared';
import { TermsConditionsDetails } from './TermsConditionsDetails';

export const termsConditionRoutes: Routable[] = [
  {
    route: '/terms-conditions',
    content: <TermsConditionsDetails />,
  },
];
